import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../../assets/images/nestle-9 1.svg";
import Filters from "../Filters";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Button,
  Checkbox,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  Chip,
} from "@mui/material";
import { TextField, InputAdornment, Tooltip } from "@mui/material";
import {
  ArrowBackOutlined,
  ArrowDropDown,
  CheckBox,
  Clear as ClearIcon,
  CloseOutlined,
} from "@mui/icons-material";
import FilterServices from "../../services/FilterServices";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import TabList from "../TabList";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import SNO from "../../assets/images/SNO.png";
import DOM from "../../assets/images/DOM.png";
import RR_Icon from "../../assets/images/RR_Icon.png";
import DO from "../../assets/images/deploymentPlanning.png";
import FG_Salage from "../../assets/images/FG Salage.png";
import FGS_Icon from "../../assets/images/FGS_Icon.png";
import Executive_View from "../../assets/images/Executive View.png";
import POOS_Icon from "../../assets/images/POOS_Icon.png";
import CP_Icon from "../../assets/images/CP_Icon.png";
import DIP_Icon from "../../assets/images/DIP_Icon.png";
import Detention_Icon from "../../assets/images/Detention_Icon.png";
import Freight_Forecasting_Icon from "../../assets/images/Freight_Forecasting_Icon.png";
import Transportation from "../../assets/images/TM.png";
import user from "../../assets/images/team.png";
import FF from "../../assets/images/Transportation.png";
import Distribution_Planning from "../../assets/images/Distribution Planning.png";
import Red_I_Icon from "../../assets/images/Red_I_Icon.png";
import Orange_I_Icon from "../../assets/images/Orange_I_Icon.png";
import CustomerService from "../../assets/images/CustomerService.png";
import NoteOutline from "../../assets/images/NoteOutline.png";
import FileManagment from "../../assets/images/file-management.png";
import NPSIcon from "../../assets/images/NPS_Icon.png";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  setDeepDriveTab,
  setDivisionList,
  setFilterList,
  setPL3List,
  setPowerBiData,
  setProductList,
  setCustomerList,
  TabActions,
  TabNameChange,
  setActiveFlag,
  setScenariosFlag,
  setScenarios,
  setRecomFlag,
  setSelectedScenarios,
  setGraphOrMapView,
  setSelectedScenariosRR,
  DateRangeFilterForRapidResponseActions,
  FacTypeFilterAction,
  setModuleTabIndex,
  setSelectedNetworksRR,
  setIncoTerm,
} from "../../store/Actions";
import GraphService from "../../services/console_services/Graph";
import { getModuleNameBasedOnPath } from "../../helper";
import { getTabIndex } from "../utils";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const drawerWidth = 60;

const useStyles = makeStyles((_theme) => ({
  filterIcon: {
    width: "25px",
    height: "25px",
    borderRadius: "50px",
    backgroundColor: "#fff",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    margin: "7px",
  },
  toolbar: {
    borderRadius: "0px 8px 0px 0px",
    background: "#0067A1",
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    overflow: "visible !important",
    display: "flex",
    justifyContent: "center",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
  },
  listItem: {
    minHeight: 48,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
  menuLabel: {
    display: "flex",
    margin: "var(--2, 8px) var(--25, 10px)",
    padding: "var(--2, 8px) var(--25, 10px)",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2px solid #F9F871",
    fontSize: "14px !important",
    marginLeft: "10px",
  },
  subMenu: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
    fontSize: "14px !important",
    // maxWidth: "200px",
    whiteSpace: "normal",
    margin: "10px 0px",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px) !important`,
    ml: `${drawerWidth}px !important`,
    background: "#FFF !important",
    boxShadow: "none !important",
    borderRadius: "0px 8px 0px 0px !important",
    overflow: "hidden !important",
    paddingRight: "5px !important",
  },
  toolBarNav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 0px 0px 25px !important",
  },
  navBarTitle: {
    flexGrow: 1,
    fontSize: "18px !important",
    fontWeight: "600 !important",
    color: "#59595A !important",
  },
  centerDiv: {
    display: "flex",
    alignItems: "center",
    // flexGrow: 1,
    // justifyContent: 'center',
  },
  renderFilters: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    marginRight: "16px",
  },
  dateClearContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "16px",
  },
  filterKey: {
    color: "#929497",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    fontFamily: "Poppins, sans-serif",
    margin: "0px 8px !important",
  },
  subTabContainer: {
    backgroundColor: "#3A6DA8",
    borderRadius: "10px",
    marginLeft: "15px",
    marginRight: "15px",
  },
  iconButtonStyle: {
    borderRadius: "50%",
    backgroundColor: "white",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "8px",
    width: "40px", // Adjust width if needed
    height: "40px", // Adjust height if needed
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  iconstyle: {
    marginLeft: "1px !important",
  },
  subTab: {
    display: "flex !important",
    justifyContent: "space-between !important",
    backgroundColor: "#3A6DA8",
    borderRadius: "8px !important",
    "&:hover": {
      backgroundColor: "#2C4C80 !important",
      cursor: "pointer",
    },
    marginLeft: "32px", // ✅ hierarchy indent
    paddingLeft: "16px",
    marginBottom: "4px !important",
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
}));

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
  {
    title: "The Lord of the Rings: The Return of the King",
    year: 2003,
  },
  { title: "The Good, the Bad and the Ugly", year: 1966 },
  { title: "Fight Club", year: 1999 },
  {
    title: "The Lord of the Rings: The Fellowship of the Ring",
    year: 2001,
  },
  {
    title: "Star Wars: Episode V - The Empire Strikes Back",
    year: 1980,
  },
  { title: "Forrest Gump", year: 1994 },
  { title: "Inception", year: 2010 },
  {
    title: "The Lord of the Rings: The Two Towers",
    year: 2002,
  },
  { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { title: "Goodfellas", year: 1990 },
  { title: "The Matrix", year: 1999 },
  { title: "Seven Samurai", year: 1954 },
  {
    title: "Star Wars: Episode IV - A New Hope",
    year: 1977,
  },
  { title: "City of God", year: 2002 },
  { title: "Se7en", year: 1995 },
  { title: "The Silence of the Lambs", year: 1991 },
  { title: "It's a Wonderful Life", year: 1946 },
  { title: "Life Is Beautiful", year: 1997 },
  { title: "The Usual Suspects", year: 1995 },
  { title: "Léon: The Professional", year: 1994 },
  { title: "Spirited Away", year: 2001 },
  { title: "Saving Private Ryan", year: 1998 },
  { title: "Once Upon a Time in the West", year: 1968 },
  { title: "American History X", year: 1998 },
  { title: "Interstellar", year: 2014 },
];

const networkOptions = [
  { entity: "Network", value: "AMBIENT" },
  { entity: "Network", value: "CHILLED" },
  { entity: "Network", value: "FROZEN" },
  { entity: "Network", value: "NPW" },
];

function ResponsiveDrawer(props) {
  const { instance } = useMsal();
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    setViewPowerBi,
    // _dateRangeFilterChange,
    // _setFilterActions,
    moduleTabIndexChange,
    handleLogout,
    viewPowerBi,
    applyFilter,
    // _date,
    // _role,
    ApplyFilterActions,
    networkFilterChange,
    tabChange,
    DCFilterChange,
    productsFilterChange,
    customersFilterChange,
    pl3FilterChange,
    cl6FilterChange,
    divisionFilterChange,
    fromStateFilterAction,
    toStateFilterAction,
    fromZipFilterAction,
    toZipFilterAction,
    laneFilterAction,
    FacIDFilterAction,
    LocationAction,
    FacTypeFilterAction,
    TemperatureFilterAction,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  // const [anchorElSelect, setAnchorElSelect] = useState(null);
  const [openScenario, setOpenScenario] = useState(null);
  const location = useLocation();
  const { pathname } = location;
  // const activeTab = pathname.split("/")[1];
  const [showFilters, setShowFilters] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(true);
  // const [subMenuAnchorEl, setSubMenuAnchorEl] = useState([]);
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
  const [openNestedSubMenuIndex, setOpenNestedSubMenuIndex] = useState(null);
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(null);

  // const [deepDiveHeader, setDeepDiveHeader] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [recom, setRecom] = useState("All");

  const incoterm = useSelector((state) => state?.filter?.incoTerm);
  const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  const scenariosDataRR = useSelector((state) => state?.filter?.scenarios);
  const selectedScenariosRR = useSelector(
    (state) => state?.filter?.selectedScenarios,
  );

  const selectedNetworksRR = useSelector(
    (state) => state?.filter?.selectedNetworks,
  );

  const activeEventsCount = useSelector(
    (state) => state?.filter?.activeEventsCount,
  );
  // const [isIconOne, setIsIconOne] = useState(true);
  const isIconOne = true;
  const [shrinkAlert, setShrinkAlert] = useState(true);
  const [lastPath, setLastPath] = useState(null);
  // const [value, setValue] = useState([]);
  // const pl3List = useSelector(state => state?.filter?.filteredList?.PL3);

  const handleShrinkAlert = () => {
    setShrinkAlert((prev) => !prev);
  };
  const [scenarios, setScenarios] = useState([]);
  const [selectedScenarios, setSelectedScenarios] = useState("");
  // const [activeValue, setActiveValue] = useState("");
  const [activeDrawer, setActiveDrawer] = useState(getTabIndex[pathname] || 1);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (pathname !== "/") {
      setActiveDrawer(getTabIndex[pathname]);
    }
  }, [location]);

  // Open Menu
  const handleOpen = (event) => {
    setOpenScenario(event.currentTarget);
  };

  // Handle Search Input
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // const handleSearchChangeRR = (event) => {
  //   setSearchQueryRR(event.target.value)
  // }
  // Filter Scenarios based on Search Query
  const filteredScenarios = scenarios?.filter((scenario) =>
    scenario?.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  // const calculateFourWeeksAgoDate = (date) => {
  //   const fourWeeksAgo = new Date(date);
  //   fourWeeksAgo.setDate(fourWeeksAgo.getDate() - 28);
  //   return fourWeeksAgo.toISOString().slice(0, 10);
  // };
  const dispatch = useDispatch();
  const store = useSelector((state) => state);

  const handleSubMenuToggle = (index, menuItem, drawer_id) => {
    console.log(drawer_id);
    setOpenSubMenuIndex(openSubMenuIndex === index ? null : index);
    if (menuItem?.label === "Raise new ticket") {
      window.open(
        "https://nestle.service-now.com/itsp?id=nesa_itsp_sc_cat_item&sys_id=86b8534983cc16980eec34226daad322",
        "_blank",
      );
    } else if (menuItem?.label === "Go to Service Now") {
      window.open("https://nestle.service-now.com/itsp", "_blank");
    }
  };
  const handleNestedSubMenuToggle = (index) => {
    setOpenNestedSubMenuIndex(openNestedSubMenuIndex === index ? null : index);
  };
  // const endDate = new Date().toISOString().slice(0, 10);
  // const startDate = calculateFourWeeksAgoDate(new Date());

  // const initialDates = [startDate, endDate];

  const handleMainClick = (event, index, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedMenuIndex(index + item?.label);
    // console.log("item: ", item)
  };

  useEffect(() => {
    setShowFilters(applyFilter.length > 0);
  }, [applyFilter]);

  useEffect(() => {
    // Store the last visited path
    if (location.pathname !== "/") {
      setLastPath(location.pathname);
    }
  }, [location]); // Ru

  const handleClose = () => {
    setOpenScenario(null);
    setSelectedMenuIndex(null);
    setSearchQuery("");
  };

  const handleParams = () => {
    return {
      module: getModuleNameBasedOnPath(window?.location?.pathname),
      filter: {
        Network: store?.filter?.Network,
        Division: store?.filter?.Division,
        ProductLevel3CategoryID: store?.filter?.PL3,
      },
    };
  };

  let ffCheck = window.location.pathname;
  const getFilterData = async () => {
    try {
      setFiltersLoading(true);

      // const [filtersResponse, productsResponse] = await Promise.all([
      //   FilterServices.getFilters(handleParams(), instance),
      //   //FilterServices.getFilters(handleParamsMaterial(), instance),
      // ]);
      const [filtersResponse] = await Promise.all([
        FilterServices.getFilters(handleParams(), instance),
        //FilterServices.getFilters(handleParamsMaterial(), instance),
      ]);

      if (filtersResponse?.response) {
        dispatch(setFilterList(filtersResponse?.response));
        dispatch(setProductList(filtersResponse?.response?.products));
        dispatch(setCustomerList(filtersResponse?.response?.SoldToName));
      }
    } catch (error) {
      console.error("Error fetching filter data:", error);
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    getFilterData();
    getScenariosNps();
  }, [
    store?.filter?.Network?.length,
    store?.filter?.Division?.length,
    store?.filter?.PL3?.length,
    store?.filter?.DC?.length,
    ffCheck,
    selectedNetwork,
  ]);

  const handleMenuClick = (path) => {
    navigate(path, { replace: true });
    if (path === "DO") {
      dispatch(TabNameChange("DO"));
    } else if (path === "/fgs") {
      dispatch(TabNameChange("FGS"));
    } else if (path === "/poos") {
      dispatch(TabNameChange("POOS"));
    } else if (path === "/cp") {
      dispatch(TabNameChange("CP"));
    } else if (path === "/dip") {
      dispatch(TabNameChange("DIP"));
    } else if (path === "/if") {
      dispatch(TabNameChange("IF"));
    } else if (path === "/nps") {
      dispatch(TabNameChange("NPS"));
    } else if (path === "/rr") {
      dispatch(TabNameChange("RR"));
    } else if (path === "/slp") {
      dispatch(TabNameChange("SLP"));
    } else if (path === "/iof") {
      dispatch(TabNameChange("IOF"));
    } else if (path === "/erm") {
      dispatch(TabNameChange("ERM"));
    } else if (path === "/tm") {
      dispatch(TabNameChange("TM"));
    }

    handleClose();
    // setDeepDiveHeader(false);
  };

  const deepDiveData = {
    Module: "",
    Entity: "",
    Metric: "",
  };

  // Helper functions for refactoring
  const handleReset = (index = null) => {
    if (index !== null) {
      tabChange(index);
      moduleTabIndexChange(0);
    }
    // setDeepDiveHeader(false);
    setViewPowerBi(false);
  };

  const createDeepDiveSubTab = (
    tabName,
    set_Active_Drawer,
    labelName = "Deep Dive",
  ) => ({
    label: <span style={{ fontSize: "14px" }}>{labelName}</span>,
    onClick: () => {
      handleMenuClick("/");
      dispatch(setDeepDriveTab(tabName));
      // setDeepDiveHeader(true);
      dispatch(setPowerBiData(deepDiveData));
      setViewPowerBi(true);
      handleClose();
      set_Active_Drawer();
    },
  });

  const handleActionClick = (path) => {
    handleMenuClick(`/action/${path}`);
    // setDeepDiveHeader(true);
    setViewPowerBi(true);
    handleClose();
  };

  const createSubTab = (label, path, tabName, onClickHandler) => ({
    label: <span style={{ fontSize: "14px" }}>{label}</span>,
    icon: (
      <span
        style={{ margin: "0px 10px", width: "24px", height: "25px" }}
      ></span>
    ),
    path,
    onClick: () => {
      if (tabName) {
        dispatch(TabNameChange(tabName));
      }
      handleMenuClick(path);
      onClickHandler();
    },
  });
  const createMenuItem = (label, iconSrc, subTabs) => ({
    label: <span style={{ fontSize: "14px" }}>{label}</span>,
    icon: (
      <img
        src={iconSrc}
        style={{ margin: "0px 10px", width: "24px", height: "25px" }}
        alt={label}
      />
    ),
    subTabs,
  });

  const drawerItems = [
    // {
    //   label: "Integrated Fulfillment",
    //   icon: <img src={Executive_View} alt="IF" />,
    //   onClick: () => handleReset(),
    //   menuItems: [
    //     createMenuItem("Integrated Fulfillment", DOM, [
    //       createSubTab("Home", "/if", "IF", () => handleReset(0)),
    //     ]),
    //   ],
    // },
    {
      id: 1,
      label: "SNO",
      icon: (
        <img
          src={SNO}
          alt="SNO"
          style={{
            filter:
              Number(activeDrawer) === 1 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        createMenuItem("SNO", DOM, [
          createSubTab("Home", "/sno", "SNO", () => {
            handleReset(0);
            setActiveDrawer(1);
          }),
          createDeepDiveSubTab("SNO", () => setActiveDrawer(1), "Deep Dive"),
        ]),
        createMenuItem("DOM", DOM, [
          createSubTab("Home", "/dom", "DOM", () => {
            handleReset(1);
            setActiveDrawer(1);
          }),
          createDeepDiveSubTab("DOM", () => setActiveDrawer(1), "Deep Dive"),
          createSubTab("Action", "/action", null, () => {
            handleActionClick("dom");
            setActiveDrawer(1);
          }),
        ]),
        createMenuItem("RR", RR_Icon, [
          createSubTab("Home", "/rr", "RR", () => {
            handleReset(2);
            setActiveDrawer(1);
          }),
          createDeepDiveSubTab("RR", () => setActiveDrawer(1), "Deep Dive"),
          createSubTab("Action", "/action", null, () => {
            handleActionClick("rr");
            setActiveDrawer(1);
          }),
        ]),
      ],
    },
    {
      id: 2,
      label: "Deployment",
      icon: (
        <img
          src={DO}
          alt="DO"
          style={{
            filter:
              Number(activeDrawer) === 2 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        createMenuItem("Deployment Planning", DOM, [
          createSubTab("Home", "/dp", "Deployment Planning", () => {
            handleReset(0);
            {
              setActiveDrawer(2);
            }
          }),
          createDeepDiveSubTab(
            "Deployment Planning",
            () => {
              setActiveDrawer(2);
            },
            "Deep Dive",
          ),
        ]),
        createMenuItem("Deployment Optimization", DOM, [
          createSubTab("Home", "/do", "Deployment Optimization", () => {
            handleReset(1);
            {
              setActiveDrawer(2);
            }
          }),
          createDeepDiveSubTab(
            "Deployment Optimization",
            () => {
              setActiveDrawer(2);
            },
            "Deep Dive",
          ),
        ]),
      ],
    },
    {
      id: 3,
      label: "Distribution Planning",
      icon: (
        <img
          src={Distribution_Planning}
          alt="DO"
          style={{
            filter:
              Number(activeDrawer) === 3 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        createMenuItem("Distribution Planning", DIP_Icon, [
          createSubTab("Home", "/dip", "Distribution Planning", () => {
            handleReset(0);
            setActiveDrawer(3);
          }),
          createDeepDiveSubTab(
            "Distribution_Planning",
            () => {
              setActiveDrawer(3);
            },
            "Deep Dive",
          ),
        ]),
        createMenuItem("Capacity Planning", CP_Icon, [
          createSubTab("Home", "/cp", "Capacity Planning", () => {
            handleReset(1);
            setActiveDrawer(3);
          }),
          createMenuItem("DeepDive", CP_Icon, [
            createDeepDiveSubTab(
              "CP Main Report",
              () => {
                setActiveDrawer(3);
              },
              "CP Main Report",
            ),
            createDeepDiveSubTab("RDP", () => setActiveDrawer(3), "RDP"),
            // createDeepDiveSubTab("RDP Frozen", "RDP Frozen"),
            createDeepDiveSubTab(
              "RDP NPW",
              () => {
                setActiveDrawer(3);
              },
              "RDP NPW",
            ),
            // createDeepDiveSubTab("RDP Chilled", "RDP Chilled"),
          ]),
          createMenuItem("Action", CP_Icon, [
            createSubTab("STCP-RDP", "/action", null, () => {
              handleActionClick("STCP-RDP");
              setActiveDrawer(3);
            }),
            createSubTab("LTCP-RDP", "/action", null, () => {
              handleActionClick("LTCP-RDP");
              setActiveDrawer(3);
            }),
          ]),
        ]),

        createMenuItem("NPS", NPSIcon, [
          createSubTab("Home", "/nps", "Network Planning Simulation", () => {
            handleReset(2);
            setActiveDrawer(3);
          }),
          createDeepDiveSubTab("NPS", () => setActiveDrawer(3), "Deep Dive"),
          createSubTab("Action", "/action", null, () => {
            handleActionClick("nps");
            setActiveDrawer(3);
          }),
        ]),
      ],
    },
    {
      id: 4,
      label: "Demand Supply Planning",
      icon: (
        <img
          src={FG_Salage}
          alt="DO"
          style={{
            filter:
              Number(activeDrawer) === 4 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        createMenuItem("FG Salvage", FGS_Icon, [
          createSubTab("Home", "/fgs", "FGS", () => {
            handleReset(0);
            setActiveDrawer(4);
          }),
          createDeepDiveSubTab("FGS", () => setActiveDrawer(4), "Deep Dive"),
          createSubTab("Action", "/action", null, () =>
            handleActionClick("fgs"),
          ),
        ]),
        createMenuItem("POOS", POOS_Icon, [
          createSubTab("Home", "/poos", "POOS", () => {
            handleReset(1);
            setActiveDrawer(4);
          }),
          createDeepDiveSubTab("POOS", () => setActiveDrawer(4), "Deep Dive"),
          createSubTab("Action", "/action", null, () => {
            handleActionClick("poos");
            setActiveDrawer(4);
          }),
        ]),
      ],
    },
    {
      id: 5,
      label: "Transportation",
      icon: (
        <img
          src={FF}
          alt="DO"
          style={{
            filter:
              Number(activeDrawer) === 5 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        // createMenuItem(
        //   "Potential Freight Opportunity",
        //   Freight_Forecasting_Icon,
        //   [
        //     createSubTab("Home", "/ff", "FF", () => {
        //       handleReset(0);
        //       setActiveDrawer(5);
        //     }),
        //     createDeepDiveSubTab("FF", () => setActiveDrawer(5), "Deep Dive"),
        //     createSubTab("Action", "/action", null, () => {
        //       handleActionClick("ff");
        //       setActiveDrawer(5);
        //     }),
        //   ],
        // ),
        createMenuItem("Detention", Detention_Icon, [
          createSubTab("Home", "/ds", "Detention", () => {
            handleReset(0);
            setActiveDrawer(5);
          }),
          // createDeepDiveSubTab("DETENTION"),
          createMenuItem("DeepDive", Detention_Icon, [
            createDeepDiveSubTab(
              "RCA Historic",
              () => {
                setActiveDrawer(5);
              },
              "RCA Historic",
            ),
            createDeepDiveSubTab(
              "Operational Account",

              () => {
                setActiveDrawer(5);
              },
              "Operational Account",
            ),
            createDeepDiveSubTab(
              "Historical Customer Facing",

              () => {
                setActiveDrawer(5);
              },
              "Historical Customer Facing",
            ),
          ]),
          createMenuItem("Action", DOM, [
            createSubTab("DC", "/action", null, () => {
              handleActionClick("DC");
              setActiveDrawer(5);
            }),
            createSubTab("3PL", "/action", null, () => {
              handleActionClick("3PL");
              setActiveDrawer(5);
            }),
            createSubTab("CONFIG", "/action", null, () => {
              handleActionClick("CONFIG");
              setActiveDrawer(5);
            }),
          ]),
        ]),
        // createMenuItem("Transportation Management", DOM, [
        //   createSubTab("Home", "/tm", "TM", () => handleReset(2)),
        //   createDeepDiveSubTab("TM"),
        //   // createSubTab("Action", "/action", null, () =>
        //   //   handleActionClick("TM")
        //   // ),
        // ]),
      ],
    },
    {
      id: 6,
      label: "Business Supply Chain",
      icon: (
        <img
          src={Executive_View}
          alt="DO"
          style={{
            filter:
              Number(activeDrawer) === 6 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        createMenuItem("Service Level Prediction", CustomerService, [
          createSubTab("Home", "/slp", "Service Level Prediction", () => {
            handleReset(0);
            setActiveDrawer(6);
          }),
          createDeepDiveSubTab(
            "SLP",
            () => {
              setActiveDrawer(6);
            },
            "Deep Dive",
          ),
        ]),
        createMenuItem("IOF-Prioritization", NoteOutline, [
          createSubTab("Home", "/iof", "IOF-Prioritization", () => {
            handleReset(1);
            setActiveDrawer(6);
          }),
          createDeepDiveSubTab(
            "IOF",
            () => {
              setActiveDrawer(6);
            },
            "Deep Dive",
          ),
        ]),
        createMenuItem("On-Time Delivery Guardian", DOM, [
          createSubTab("Home", "/iofpb", "IOFPB", () => {
            handleReset(2);
            setActiveDrawer(6);
          }),
          // createDeepDiveSubTab("IOFPB"),
          // createSubTab("Action", "/action", null, () => handleActionClick("iob")
          // ),
        ]),
        // createMenuItem("Exception Reason Managment", FileManagment, [
        //   createSubTab("Home", "/erm", "ERM", () => {
        //     handleReset(3);
        //     setActiveDrawer(6);
        //   }),
        //   // createDeepDiveSubTab("ERM"),
        // ]),
      ],
    },
  ];

  const bottomDrawerItems = [
    {
      id: 7,
      label: "User",
      icon: (
        <img
          src={user}
          alt="DO"
          style={{
            filter:
              Number(activeDrawer) === 7 ? "brightness(0) invert(1)" : "none",
          }}
        />
      ),
      onClick: () => handleReset(),
      menuItems: [
        createMenuItem("User Access Management", DOM, [
          createSubTab("Home", "/ua", "User Access Management", () => {
            handleReset(0);
            setActiveDrawer(7);
          }),
        ]),
        createMenuItem("Module Run Status", DOM, [
          createSubTab("Home", "/mrs", "Module Run Status", () => {
            handleReset(1);
            setActiveDrawer(7);
          }),
        ]),
      ],
    },
    {
      id: 8,
      label: "Help",
      icon: (
        <InfoOutlinedIcon
          fontSize="small"
          style={{
            color: "#2B5692",
            cursor: "pointer",
          }}
        />
      ),
      menuItems: [
        createMenuItem("Raise new ticket", DOM),
        createMenuItem("Go to Service Now", DOM),
      ],
    },
  ];

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (window.location.pathname === "/" && !viewPowerBi && userDetails) {
      navigate("/sno");
    }
  }, [navigate]);

  const drawerListRender = (renderItemList) => {
    return (
      <div style={{ width: "100%" }}>
        {renderItemList.map((item, index) => (
          <div
            key={index + item.label}
            style={{
              width: "100%",
            }}
          >
            <ListItem
              sx={{
                display: "block !important",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
              }}
            >
              <Tooltip
                title={item.label}
                placement="right"
                PopperProps={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 0],
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#0067A1",
                      color: "white",
                      fontSize: "12px",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#0067A1",
                    },
                  },
                }}
                arrow
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: "center !important",
                    display: "flex !important",
                    alignItems: "center !important",
                    p: 0,
                    backgroundColor:
                      Number(activeDrawer) === item.id
                        ? "rgb(0, 103, 161) !important"
                        : "transparent",
                    "&:hover": {
                      backgroundColor: "rgba(0, 102, 161, 0.35)",
                    },
                    "&.Mui-focusVisible": {
                      backgroundColor:
                        Number(activeDrawer) === item.id
                          ? "rgb(0, 103, 161)"
                          : "transparent",
                    },
                    "&:active": {
                      backgroundColor:
                        Number(activeDrawer) === item.id
                          ? "rgb(0, 103, 161) !important"
                          : "transparent",
                    },
                  }}
                  onClick={(event) => handleMainClick(event, index, item)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      justifyContent: "center",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                </ListItemButton>
              </Tooltip>
            </ListItem>
            {item.menuItems && item.label && (
              <Menu
                anchorEl={anchorEl}
                open={
                  selectedMenuIndex === index + item.label && Boolean(anchorEl)
                }
                onClose={handleClose}
                keepMounted
                PaperProps={{
                  style: {
                    borderRadius: "0px 8px 8px 0px",
                    background: "#2B5692",
                    color: "#fff",
                    maxHeight: "80vh", // ✅ allow tall menus
                    overflowY: "auto", // ✅ scroll instead of cut
                    overflowX: "hidden",
                  },
                }}
              >
                <div className={classes.menuLabel}>
                  {item.label}

                  <div onClick={handleClose} style={{ cursor: "pointer" }}>
                    <CloseOutlined />
                  </div>
                </div>
                {item.menuItems.map((menuItem, menuIndex) => (
                  <React.Fragment key={`menuItem-${menuIndex}`}>
                    <MenuItem
                      onClick={() =>
                        handleSubMenuToggle(menuIndex, menuItem, item.id)
                      }
                      className={classes.subMenu}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ alignSelf: "center" }}>
                          {menuItem.icon}
                        </div>
                        <div style={{ alignSelf: "center" }}>
                          {menuItem.label}
                        </div>
                      </div>
                      {menuItem.subTabs && <ArrowDropDown />}
                    </MenuItem>

                    {/* Render subTabs if the submenu is open */}
                    {openSubMenuIndex === menuIndex &&
                      menuItem.subTabs &&
                      menuItem.subTabs.map((subMenuTab, subMenuTabIndex) => {
                        // If subTab has a "subTabs" property, it's a nested submenu
                        return subMenuTab?.hasOwnProperty("subTabs") ? (
                          <React.Fragment key={`subTab-${subMenuTabIndex}`}>
                            <MenuItem
                              onClick={() =>
                                handleNestedSubMenuToggle(
                                  subMenuTabIndex,
                                  item.id,
                                )
                              }
                              className={classes.subTab}
                              style={{ marginLeft: "55px !important" }}
                            >
                              <div
                                style={{ display: "flex", alignSelf: "center" }}
                              >
                                {" "}
                                {subMenuTab.label}{" "}
                              </div>

                              <div>{menuItem.subTabs && <ArrowDropDown />}</div>
                              {/* Placeholder for "Action" text */}
                            </MenuItem>

                            {/* Render nested subTabs if the subTab is selected */}
                            {openNestedSubMenuIndex === subMenuTabIndex &&
                              subMenuTab.subTabs &&
                              subMenuTab.subTabs.map((tab, tabIndex) => (
                                <MenuItem
                                  key={`nestedSubTab-${tabIndex}`}
                                  onClick={tab.onClick}
                                  className={classes.nestedSubTab}
                                  style={{
                                    marginLeft: "65px",
                                    fontSize: "14px",
                                    display: "flex",
                                  }}
                                >
                                  <div style={{ alignSelf: "center" }}>
                                    {tab.icon}
                                  </div>
                                  <div style={{ alignSelf: "center" }}>
                                    {tab.label}
                                  </div>
                                </MenuItem>
                              ))}
                          </React.Fragment>
                        ) : (
                          // If subTab doesn't have "subTabs" property, render a normal MenuItem
                          <MenuItem
                            key={`subTab-${subMenuTabIndex}`}
                            onClick={subMenuTab.onClick}
                            className={classes.subTab}
                            style={{ marginLeft: "55px" }}
                          >
                            {subMenuTab.label}
                          </MenuItem>
                        );
                      })}
                  </React.Fragment>
                ))}
              </Menu>
            )}
          </div>
        ))}
      </div>
    );
  };

  const drawer = (
    <div style={{ height: "calc(100% - 64px)" }}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          sx={{ marginLeft: 0 }}
        >
          <img src={logo} alt="Logo" width={40} height={40} />
        </IconButton>
      </Toolbar>
      <List className={classes.list}>
        {drawerListRender(drawerItems)}
        {drawerListRender(bottomDrawerItems)}
      </List>
    </div>
  );
  // const handleClear = (filterKey) => {
  //   const updatedFilters = applyFilter.map((filter) => {
  //     // const { [filterKey]: _, ...rest } = filter;
  //      const { [filterKey]: unused, ...rest } = filter;
  //     return rest;
  //   });
  //   const filterChangeMap = {
  //     Network: networkFilterChange,
  //     DC: DCFilterChange,
  //     Division: divisionFilterChange,
  //     PL3: pl3FilterChange,
  //     CL6: cl6FilterChange,
  //     Products: productsFilterChange,
  //     Customers: customersFilterChange,
  //   };
  //   if (filterChangeMap[filterKey]) {
  //     const resetValue = filterKey === "Products" ? [] : "";
  //     filterChangeMap[filterKey](resetValue);
  //   }
  //   ApplyFilterActions(updatedFilters);
  // };

  // const renderFilterValues = (value, key) => {
  //   let filterValues = value;
  //   if (key === "PL3") {
  //     filterValues = filterValues?.map((filterVal) => {
  //       const matchingItem = pl3List?.find(item => item?.ProductLevel3CategoryDescription === filterVal);
  //       return matchingItem ? `${matchingItem?.ProductLevel3CategoryID} - ${matchingItem?.ProductLevel3CategoryDescription}` : matchingItem?.ProductLevel3CategoryDescription;
  //     });
  //   }
  //   const displayValue =
  //     key === "Products"
  //       ? `${filterValues?.length} products`
  //       : filterValues === ""
  //         ? "All"
  //         : filterValues?.join(", ");

  //   return (
  //     <Tooltip title={key === "Products" ? "" : displayValue}>
  //       <TextField
  //         hiddenLabel
  //         value={displayValue}
  //         id="payload-decrease"
  //         variant="outlined"
  //         size="small"
  //         InputProps={{
  //           endAdornment: filterValues && (
  //             <InputAdornment position="end">
  //               <IconButton
  //                 aria-label="clear input"
  //                 onClick={() => handleClear(key)}
  //                 edge="end"
  //                 sx={{ p: 0.5 }}
  //               >
  //                 <ClearIcon sx={{ fontSize: 16 }} />
  //               </IconButton>
  //             </InputAdornment>
  //           ),
  //         }}
  //         sx={{
  //           "& .MuiInputBase-input": {
  //             height: "15px",
  //             fontSize: "12px",
  //             color: "#333",
  //             fontWeight: "500",
  //             fontFamily: "Poppins, sans-serif",
  //             whiteSpace: "nowrap",
  //           },
  //           "& .MuiOutlinedInput-root": {
  //             borderRadius: "8px",
  //             border: "1px solid  #E6E7E8",
  //             background: "#F7F7F7",
  //             maxWidth: "120px !important",
  //           },
  //         }}
  //       />
  //     </Tooltip>
  //   );
  // };

  // const isDateFilter = (key) => {
  //   return key.toLowerCase().includes("date");
  // };

  // const validTabNames = [
  //   "Deployment Planning",
  //   "Deployment Optimization",
  //   "SNO",
  //   "DOM",
  //   "FF",
  // ];

  // const renderContent = validTabNames.includes(store?.tabs?.tabName);
  // const renderFilters = () => {
  //   if (applyFilter.length === 0) return null;
  //   const filter = applyFilter[0];
  //   if (!filter) return null; // Add this check to avoid undefined errors

  //   if (renderContent) {
  //     return Object.keys(filter).map((key) => {
  //       const value = filter[key];
  //       if (
  //         value === null ||
  //         value === undefined ||
  //         value === "" ||
  //         (Array.isArray(value) && value.length === 0)
  //       )
  //         return null;
  //       if (isDateFilter(key)) return null;
  //       return (
  //         <div key={key} className={classes.centerDiv}>
  //           <Typography className={classes.filterKey}>{key}</Typography>
  //           <Typography>{renderFilterValues(value, key)}</Typography>
  //         </div>
  //       );
  //     });
  //   } else {
  //     return Object.keys(filter).map((key) => {
  //       const value = filter[key];
  //       if (
  //         value === null ||
  //         value === undefined ||
  //         value === "" ||
  //         (Array.isArray(value) && value.length === 0)
  //       )
  //         return null;
  //       if (key !== "Network" && key !== "DC") return null;
  //       if (isDateFilter(key)) return null;
  //       return (
  //         <div key={key} className={classes.centerDiv}>
  //           <Typography className={classes.filterKey}>{key}</Typography>
  //           <Typography>{renderFilterValues(value, key)}</Typography>
  //         </div>
  //       );
  //     });
  //   }
  // };
  const handleClearAllFilters = () => {
    // Clear UI filters
    setShowFilters(false);
    ApplyFilterActions([]);
    networkFilterChange([]);
    DCFilterChange([]);
    productsFilterChange([]);
    customersFilterChange([]);
    pl3FilterChange([]);
    cl6FilterChange([]);
    divisionFilterChange([]);
    //dateRangeFilterChange(initialDates);
    fromStateFilterAction([]);
    toStateFilterAction([]);
    fromZipFilterAction([]);
    toZipFilterAction([]);
    laneFilterAction([]);
    FacIDFilterAction([]);
    LocationAction([]);
    TemperatureFilterAction([]);
    FacTypeFilterAction([]);
    // Update LastFilterID in local storage
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (!userDetails) {
      return;
    }
    if (!Array.isArray(userDetails.loginLogOutDetails)) {
      userDetails.loginLogOutDetails = [{}];
    }
    userDetails.loginLogOutDetails[0] = {
      ...userDetails.loginLogOutDetails[0],
      LastFilterID: {},
      LastViewPage: "",
    };
    localStorage.setItem("userDetails", JSON.stringify(userDetails));
  };

  const handleBack = () => {
    setViewPowerBi(false);
    dispatch(setPowerBiData([]));
    dispatch(setDeepDriveTab(""));
    navigate(lastPath);
  };

  const handleActiveChange = (e) => {
    dispatch(setActiveFlag(e.target.value));
  };

  const handleIncoTerm = (event) => {
    dispatch(setIncoTerm(event?.target?.value));
  };
  const handleScenariosChange = (scenario) => {
    dispatch(setScenariosFlag(scenario));
    setSelectedScenarios(scenario);
    handleClose();
  };

  const handleRecomChange = (e) => {
    setRecom(e.target.value);
    dispatch(setRecomFlag(e.target.value));
  };

  const handleSelectedNetworksChangeRR = (event) => {
    const { value } = event.target;
    setSelectedNetwork(value);
    dispatch(setSelectedNetworksRR(value));
  };

  const addAMonthToCurrentDate = () => {
    const rapidResponseFutureDate = new Date();
    rapidResponseFutureDate.setDate(rapidResponseFutureDate.getDate() + 30);
    return rapidResponseFutureDate.toISOString().slice(0, 10);
  };

  const calculateOneWeeksAgoDate = (date) => {
    const oneWeekAgo = new Date(date);
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    return oneWeekAgo.toISOString().slice(0, 10);
  };

  const handleRRNotificationClick = () => {
    dispatch(setGraphOrMapView("Map View"));
    const oneWeekAgoDate = calculateOneWeeksAgoDate(new Date());
    const nextMonthDate = addAMonthToCurrentDate();
    dispatch(
      DateRangeFilterForRapidResponseActions([oneWeekAgoDate, nextMonthDate]),
    );
  };

  const renderTypographyContent = () => {
    return "Integrated Fulfillment Command Centre";
  };

  const handleClearSelection = () => {
    dispatch(setScenariosFlag(""));
    setSelectedScenarios("");
    dispatch(setSelectedNetworksRR([]));
  };

  const getScenariosNps = (_params) => {
    let paramsL = {
      Module: window.location.pathname === "/iof" ? "IOFPRIORITIZATION" : "NPS",
      Network: selectedNetwork,
    };
    GraphService.getScenariosNps(paramsL)
      .then((data) => {
        if (data?.data) {
          if (window.location.pathname === "/iof") {
            const updatedScenarios = data?.data.map((scenario) => ({
              ScenarioName: scenario.ScenerioName,
            }));
            setScenarios(updatedScenarios);
          } else {
            setScenarios(data?.data);
          }
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => console.log("Success"));
  };

  console.log("applyFilter", applyFilter);
  const selectedFilterCount =
    Array.isArray(applyFilter) && applyFilter.length > 0 && applyFilter[0]
      ? Object.entries(applyFilter[0] || {}) // Ensure applyFilter[0] is an object
          .filter(
            ([key, value]) =>
              key !== "Date" && Array.isArray(value) && value.length > 0,
          ).length
      : 0;

  return (
    <Box>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolBarNav}>
          <div className={classes.navBarTitle}>
            <div className={classes.centerDiv}>
              {viewPowerBi && (
                <IconButton
                  className={classes.iconButtonStyle}
                  color="primary"
                  onClick={() => handleBack()}
                >
                  <ArrowBackIosIcon className={classes.iconstyle} />
                </IconButton>
              )}
              <Typography variant="h6" className={classes.iconstyle}>
                {renderTypographyContent()}
              </Typography>
            </div>
          </div>
          {pathname === "/poos" && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <InputLabel id="active-select-label">
                  Recommended/Active
                </InputLabel>
              </div>
              <ListItem>
                <Select
                  labelId="active-select-label"
                  value={activeFlagValue}
                  onChange={handleActiveChange}
                  className={classes.select}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={1}>Active only</MenuItem>
                  <MenuItem value={2}>All</MenuItem>
                  <MenuItem value={0}>Recommended not active</MenuItem>
                </Select>
              </ListItem>
            </div>
          )}
          {pathname === "/rr" && activeEventsCount > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                background: "#FCF2CF",
                paddingLeft: "10px",
                paddingRight: "10px",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  marginTop: "5px",
                  cursor: "pointer",
                }}
                onClick={handleShrinkAlert}
              >
                <img
                  src={isIconOne ? Red_I_Icon : Orange_I_Icon}
                  alt="icon"
                  style={{ width: 25, height: 25 }}
                />
              </div>
              {shrinkAlert && (
                <>
                  <div
                    style={{
                      padding: "4px",
                      color: "#302003",
                      cursor: "pointer",
                    }}
                    onClick={handleRRNotificationClick}
                  >
                    <u>Force Majeure event on going</u>
                  </div>
                  <div
                    style={{
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      color: "#707070",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                    onClick={handleShrinkAlert}
                  >
                    X
                  </div>
                </>
              )}
            </div>
          )}
          {pathname === "/rr" && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Select
                labelId="active-select-label"
                value={selectedNetworksRR}
                onChange={handleSelectedNetworksChangeRR}
                className={classes.select}
                displayEmpty
                multiple
                inputProps={{ "aria-label": "Without label" }}
                sx={{ width: "180px", height: "35px" }}
                renderValue={(selected) =>
                  selected?.length > 0
                    ? selected?.length === 1
                      ? "1 Network Selected"
                      : `${selected?.length} networks selected`
                    : "Select Network"
                }
              >
                {networkOptions?.map((item) => (
                  <MenuItem key={item?.value} value={item?.value}>
                    <Checkbox
                      checked={selectedNetworksRR?.indexOf(item?.value) > -1}
                    />
                    <ListItemText primary={item?.value} />
                  </MenuItem>
                ))}
              </Select>

              <Autocomplete
                multiple
                value={selectedScenariosRR}
                onChange={(_event, newValue) =>
                  dispatch(setSelectedScenariosRR([...newValue]))
                }
                id="checkboxes-tags-demo"
                options={scenariosDataRR}
                disableCloseOnSelect
                getOptionLabel={(option) => option?.value}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option?.value}
                    </li>
                  );
                }}
                style={{ width: 250 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      selectedScenariosRR?.length === 0
                        ? "Search Scenarios"
                        : selectedScenariosRR?.length === 1
                          ? "1 Scenario Selected"
                          : `${selectedScenariosRR?.length} Scenarios Selected`
                    }
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: "14px", padding: "0px 10px" }, // smaller font size and padding
                    }}
                    InputLabelProps={{
                      style: { fontSize: "14px" }, // smaller label font size
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "black", // Set text color to black (input text color)
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "black !important", // Force placeholder color to black
                      },
                      "& .MuiInputBase-root": {
                        "& input::placeholder": {
                          color: "black !important", // Ensure it takes precedence
                        },
                      },
                    }}
                  />
                )}
                sx={{
                  "& .MuiAutocomplete-listbox": {
                    maxHeight: 200, // Adjust the max height of the dropdown menu
                  },
                  "& .MuiChip-root": {
                    height: 18, // Reduce height of selected chip
                    fontSize: "14px", // Reduce font size of the selected tag (chip)
                    padding: "0px 4px", // Reduce padding inside the chip
                  },
                }}
                renderTags={() => null}
              />

              <Select
                labelId="active-select-label"
                value={recom}
                onChange={handleRecomChange}
                className={classes.select}
                sx={{ width: "180px", height: "35px" }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value={"All"}>All Recommended</MenuItem>
                <MenuItem value={"Accepted"}>Accepted</MenuItem>
              </Select>
            </div>
          )}
          {pathname === "/nps" && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Select
                labelId="active-select-label"
                value={selectedNetworksRR}
                onChange={handleSelectedNetworksChangeRR}
                className={classes.select}
                displayEmpty
                multiple
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  width: "180px",
                  height: "35px",
                  border: "0px solid #0067A1", // Blue border
                  color: "#0067A1", // Ensures selected value is #0067A1
                  "& .MuiSelect-select": {
                    color: "#0067A1", // Selected value color
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0067A1", // Blue border for outlined variant
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0067A1", // Ensure border remains #0067A1 on hover
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#0067A1", // Placeholder text color
                    opacity: 1, // Ensure it's visible
                  },
                }}
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return (
                      <span style={{ color: "#0067A1" }}>Select Network</span>
                    ); // Placeholder in blue
                  }
                  return selected.length === 1
                    ? "1 Network Selected"
                    : `${selected.length} networks selected`;
                }}
              >
                {networkOptions?.map((item) => (
                  <MenuItem key={item?.value} value={item?.value}>
                    <Checkbox
                      checked={selectedNetworksRR?.indexOf(item?.value) > -1}
                    />
                    <ListItemText primary={item?.value} />
                  </MenuItem>
                ))}
              </Select>

              <div>
                <ListItem>
                  <Button
                    onClick={handleOpen}
                    variant="outlined"
                    sx={{ width: "200px", textAlign: "left" }}
                  >
                    {selectedScenarios
                      ? selectedScenarios.length > 10
                        ? `${selectedScenarios.slice(0, 10)}...`
                        : selectedScenarios
                      : "Select Scenarios..."}
                  </Button>
                  <Button
                    onClick={handleClearSelection}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      fontSize: "0.6rem",
                      padding: "0.1px 0.5px",
                      marginLeft: "10px",
                    }}
                  >
                    Clear
                  </Button>
                </ListItem>

                <Menu
                  anchorEl={openScenario}
                  open={Boolean(openScenario)}
                  onClose={handleClose}
                  PaperProps={{ style: { maxHeight: 250, width: "270px" } }}
                  disableAutoFocusItem
                >
                  {/* Search Input */}
                  <MenuItem disableRipple>
                    <TextField
                      placeholder="Search..."
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      autoFocus
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                  </MenuItem>
                  {/* Filtered Options */}
                  {filteredScenarios?.length > 0 ? (
                    filteredScenarios.map((scenario, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => handleScenariosChange(scenario)} // Fix: Pass full scenario object
                      >
                        {scenario}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No results found</MenuItem>
                  )}
                </Menu>
              </div>
            </div>
          )}
          {pathname === "/iofpb" && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <InputLabel id="active-select-label">IncoTerm</InputLabel>
              </div>
              <ListItem>
                <Select
                  labelId="active-select-label"
                  value={incoterm}
                  onChange={handleIncoTerm}
                  className={classes.select}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"All"}>All</MenuItem>
                  <MenuItem value={"DDP"}>DDP</MenuItem>
                  <MenuItem value={"EXW"}>EXW</MenuItem>
                </Select>
              </ListItem>
            </div>
          )}

          {/* <div className={classes.centerDiv}>
            {showFilters && renderFilters()}
          </div> */}

          <div className={classes.centerDiv}>
            <div>
              {showFilters && (
                <Button
                  variant="text"
                  onClick={handleClearAllFilters}
                  style={{
                    fontSize: "13px",
                    textTransform: "none",
                    backgroundColor: selectedFilterCount > 0 ? "yellow" : "",
                    borderRadius: "10px",
                    marginLeft: "10px",
                  }}
                >
                  {selectedFilterCount > 0
                    ? `Clear All (${selectedFilterCount} Filter Selected)`
                    : "Clear All"}
                </Button>
              )}
            </div>
            <Filters
              handleLogout={handleLogout}
              filtersLoading={filtersLoading}
            />
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
          overflow: "hidden",
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={true}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: drawerWidth, overflow: "hidden" },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              border: "none !important",
              borderRadius: "8px 0px 0px 8px",
              background: "#FFF",
              boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
              overflow: "hidden",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          overflow: "hidden",
        }}
      >
        <Toolbar />
      </Box>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  role: state.login.role,
  applyFilter: state.filter.applyFilter,
  viewPowerBi: state.viewPowerBi.viewPowerBi,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  networkFilterChange: (newValue) =>
    dispatch({ type: "FILTER_NETWORK", payload: newValue }),
  DCFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DC", payload: newValue }),
  productsFilterChange: (newValue) =>
    dispatch({ type: "FILTER_PRODUCTS", payload: newValue }),
  customersFilterChange: (newValue) =>
    dispatch({ type: "FILTER_CUSTOMERS", payload: newValue }),

  pl3FilterChange: (newValue) =>
    dispatch({ type: "FILTER_PL3", payload: newValue }),
  cl6FilterChange: (newValue) =>
    dispatch({ type: "FILTER_CL6", payload: newValue }),

  divisionFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DIVISION", payload: newValue }),
  setFilterActions: (filtersList) =>
    dispatch({ type: "SET_FILTER", payload: filtersList }),
  ApplyFilterActions: (newValue) =>
    dispatch({ type: "APPLY_FILTER", payload: newValue }),
  setViewPowerBi: (newValue) =>
    dispatch({ type: "SET_VIEW_POWER_BI", payload: newValue }),
  dateRangeFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DATERANGE", payload: newValue }),

  fromStateFilterAction: (value) =>
    dispatch({ type: "FROM_STATE", payload: value }),
  toStateFilterAction: (value) =>
    dispatch({ type: "TO_STATE", payload: value }),
  fromZipFilterAction: (value) =>
    dispatch({ type: "FROM_ZIP", payload: value }),
  toZipFilterAction: (value) => dispatch({ type: "TO_ZIP", payload: value }),
  laneFilterAction: (value) => dispatch({ type: "LANE", payload: value }),
  TemperatureFilterAction: (value) =>
    dispatch({ type: "TEMPERATURE", payload: value }),
  FacIDFilterAction: (value) => dispatch({ type: "FAC_ID", payload: value }),
  LocationAction: (value) => dispatch({ type: "LOCATION", payload: value }),
  FacTypeFilterAction: (value) =>
    dispatch({ type: "FAC_TYPE", payload: value }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveDrawer);
